// Exports a module containing functions for dialogs, but also handles the set
// up of the dialogs for the "show data as" menu.

import { config } from './config';
import { announce } from './announcer'; // for a screen reader

/**
 *  The version of FHIR output by this app (in the "show" dialogs).
 */
const outputFHIRVersion_ = 'R4';

/**
 *  A reference to the element into which the form will be placed.
 */
const formContainer_ = document.getElementById(config.formContainer);


export const Dialogs = {
  /**
   *  Initialization, to set up event handlers for showing dialogs.
   * @param formContainer a refernece to the element containing the form.
   */
  init: function(formContainer) {
    this.formContainer_ = formContainer;

    // Handle the copy button on the dialog
    document.getElementById('copyToClipboardBtn').addEventListener('click', ()=>{
      window.getSelection().selectAllChildren(document.getElementById('message-body'));
      /* Copy the text inside the element */
      document.execCommand("Copy");
      announce('The data from the dialog has been copied to the clipboard.');
    });


    // Set up the "show data" menu items
    /*
    document.getElementById('showFHIRSDCQuestionnaire').addEventListener('click', ()=>{
      Dialogs.showFHIRSDCQuestionnaire();
    });
    */

    ['showFHIRSDCQuestionnaire', 'showFHIRSDCQuestionnaireResponse',
     'showFHIRDiagnosticReport', 'showHL7Segments'].forEach((menuID)=>{
      document.getElementById(menuID).addEventListener('click', ()=>{
        Dialogs[menuID]();
      });
    });
  },


  /**
   *  Shows a dialog for the "show data as" menu items.
   * @param title the dialog title
   * @param data the data to show
   * @param note (optional) a note to show over the data
   */
  showDataDialog: function (title, data, note) {
    document.getElementById('modal-title').textContent = title;
    document.getElementById('message-note').textContent = note || '';
    document.getElementById('message-body').textContent = data;
    // $: Bootstrap's plugins are based on jQuery
    $('#dataDialog').modal('show');
  },


  /**
   *  Shows the  FHIR SDC Questionnaire data in a dialog
   * @param event
   */
  showFHIRSDCQuestionnaire: function (event) {
    var sdc = LForms.Util.getFormFHIRData('Questionnaire',
      outputFHIRVersion_, formContainer_);
    var fhirString = JSON.stringify(sdc, null, 2);
    this.showDataDialog("FHIR SDC Questionnaire Content", fhirString);
  },


  /**
   * Show FHIR SDC QuestionnaireResponse data in a dialog
   * @param event
   */
  showFHIRSDCQuestionnaireResponse: function (event) {
    var sdc = LForms.Util.getFormFHIRData('QuestionnaireResponse',
      outputFHIRVersion_, formContainer_);
    var fhirString = JSON.stringify(sdc, null, 2);
    this.showDataDialog("FHIR SDC QuestionnaireResponse Content", fhirString);
  },


  /**
   * Show FHIR DiagnosticReport data in a dialog
   * @param event
   */
  showFHIRDiagnosticReport: function (event) {
    var dr = LForms.Util.getFormFHIRData('DiagnosticReport',
      outputFHIRVersion_, formContainer_);
    var fhirString = JSON.stringify(dr, null, 2);
    const note = "This Diagnostic Report was written for FHIR version DSTU2, and"+
      " might not be up to date with later versions."
    this.showDataDialog("FHIR Diagnostic Report Content", fhirString, note);
  },


  /**
   * Show HL7 messages in a dialog
   * @param event
   */
  showHL7Segments: function (event) {
    const formData = LForms.Util.getFormData(formContainer_, true, true);
    let hl7String = LForms.HL7.toHL7Segments(new LForms.LFormsData(formData));
    // Replace \r with \r\n so that when assigning to textContent, the segments
    // will appear on separate lines.
    hl7String = hl7String.replace(/\r/g, "\r\n");
    const note = 'Please note that this is still a work in progress, and the '+
      'code system values might be incorrect in some places.';
    this.showDataDialog("HL7 OBR & OBX Segments", hl7String, note);
  }

}

